import React, { Component } from 'react';
import PropTypes from 'prop-types';


export default class EstablishmentMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mounted: false,
    };
  }

  componentDidMount() {
    const { isMounted } = this.props;
    const { mounted } = this.state;

    if (isMounted && !mounted) this.createMap();
  }

  componentWillReceiveProps(nextProps) {
    const { isMounted } = this.props;
    const { mounted } = this.state;

    if (nextProps.isMounted !== isMounted && !mounted) this.createMap();
  }

  createMap() {
    const { latitude, longitude } = this.props;
    const establishmentPosition = { lat: latitude, lng: longitude };
    this.map = new global.google.maps.Map(this.mapDOMNode, {
      center: establishmentPosition,
      clickableIcons: false,
      disableDefaultUI: false,
      gestureHandling: 'cooperative',
      scrollwheel: false,
      zoom: 17,
    });
    this.marker = this.addMarker(this.map, establishmentPosition);
    this.setState({ mounted: true });
  }

  addMarker(map, position) {
    return new global.google.maps.Marker({
      icon: {
        origin: new global.google.maps.Point(0, 0),
        scaledSize: new global.google.maps.Size(60, 60),
        size: new global.google.maps.Size(60, 60),
        url: '/img/map/blue-cercle.png',
      },
      map,
      position,
    });
  }

  render() {
    const { t } = this.props;
    return (
      <div className="establishment-page__map">
        <h2 className="establishment-page__map__title">
          { t('Location') }
        </h2>
        <div ref={ (div) => { this.mapDOMNode = div; } } className="establishment-page__map__map" />
      </div>
    );
  }
}

EstablishmentMap.defaultProps = {
  isMounted: false,
};

EstablishmentMap.propTypes = {
  isMounted: PropTypes.bool,
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired,
};
